// index.js
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./state/store";
import { SocketProvider } from "./context/SocketContext";
import { ToastProvider } from "./context/ToastContext";
import { Auth0ProviderWithHistory } from "./Auth0ProviderWithHistory";

// ────────────────────────────────────────────────
// NO SESSION MANAGEMENT HERE - Moved to sessionManager service
// ────────────────────────────────────────────────
import { ComplianceProvider } from "context/ComplianceContext";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <Auth0ProviderWithHistory>
          <ToastProvider>
            <SocketProvider url={process.env.REACT_APP_BASE_API_URL}>
              <ComplianceProvider>
                <App />
              </ComplianceProvider>
            </SocketProvider>
          </ToastProvider>
        </Auth0ProviderWithHistory>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
